import Background from '../assets/images/slide1.png';
import Logo from '../assets/images/logo.png';

const Banner = () => {
  return (
    <div className="relative h-screen" id="home">
      <img
        className="absolute inset-0 w-full h-full object-contain"
        src={Background}
        alt="Background"
      />

      <div className="absolute inset-0 bg-bl;ue opacity-50"></div>

      <div className="absolute p-8 text-white sm:top-0 sm:left-0">
        <h1 className="text-4xl font-bold">NZQFMGB™</h1>
        <p>Build Active, Integrable, and "Intelligent" Documents</p>
      </div>

      <div  style={{ position:'fixed', bottom: '-15px' }}>
        <img src={Logo} alt=""  className="w-48 lg:w-56 sm:w-32"/>
      </div>
    </div>
  );
};

export default Banner;